import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Box } from "@mui/material";
import ShowTimeTable from "../TimeTable/ShowTimeTable";
import AllteacherTimetable from "../TimeTable/AllteacherTimetable";
import { setStepIndex, startTour } from "../../../redux/globalJoyrideSlice";
import { teacherPlannerTourSteps } from "../../../tour/teacherPlanerTourSteps";
const TimetableNav = () => {
  const [activeTab, setActiveTab] = useState("all");
 const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      startTour({
        activeTour: "teacher-planner",
        steps: teacherPlannerTourSteps(),
      })
    );
  }, [dispatch]);

  return (
    <Box>
      <Box sx={{ display: "flex", gap: 2, mb: 2, marginLeft: 6 }}>
        <Button
          variant={activeTab === "all" ? "contained" : "outlined"}
          onClick={() => setActiveTab("all")}
        >
          All Teachers Timetable
        </Button>
        <Button
        data-tour="my-timetable-btn"
          variant={activeTab === "my" ? "contained" : "outlined"}
          onClick={() =>{ setActiveTab("my")}
          }
        >
          My Timetable
        </Button>
      </Box>

      <Box>
        {activeTab === "all" && <AllteacherTimetable />}
        {activeTab === "my" && <ShowTimeTable />}
      </Box>
    </Box>
  );
};

export default TimetableNav;
